/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{animateValue as e}from"./js/index.js";import{noop as o}from"../../utils/noop.js";function t({keyframes:t,delay:n,onUpdate:r,onComplete:p}){const s=()=>(r&&r(t[t.length-1]),p&&p(),{time:0,speed:1,duration:0,play:o,pause:o,stop:o,then:e=>(e(),Promise.resolve()),cancel:o,complete:o});return n?e({keyframes:[0,1],duration:0,delay:n,onComplete:s}):s()}export{t as createInstantAnimation};
//# sourceMappingURL=instant.js.map
